var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contest-picks-page--header" }, [
    _c(
      "div",
      { staticClass: "contest-header-info" },
      [
        _c(
          "div",
          { staticClass: "contest-header-info--name" },
          [
            _c("span", { staticClass: "contest-info-name-details" }, [
              _c("span", {
                staticClass: "contest-info-name-details--usericon"
              }),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.contestEntryAlias))
              ])
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "contest-info-arrow",
                class: {
                  "switch-alias-popup-active": _vm.showPopupSwitchAlias
                },
                on: {
                  click: function($event) {
                    return _vm.toggleSwitchAliasPopup(!_vm.showPopupSwitchAlias)
                  }
                }
              },
              [
                !_vm.showPopupSwitchAlias
                  ? _c("v-icon", [_vm._v("expand_more")])
                  : _c("v-icon", [_vm._v("expand_less")])
              ],
              1
            ),
            _vm._v(" "),
            _c("contests-switch-alias-dialog", {
              attrs: { showPopupSwitchAlias: _vm.showPopupSwitchAlias },
              on: { "switch-alias-popup-close": _vm.toggleSwitchAliasPopup }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "contest-header-info--more" }, [
          _c(
            "span",
            {
              on: {
                click: function($event) {
                  _vm.showReportSliderMenu = true
                }
              }
            },
            [_c("v-icon", [_vm._v("more_vert")])],
            1
          )
        ]),
        _vm._v(" "),
        _vm.mobileBigAndBelow
          ? _c("contests-report-slider-menu", {
              attrs: {
                isSlider: true,
                showReportSliderMenu: _vm.showReportSliderMenu,
                contest: _vm.contest,
                contestEntryId: _vm.contestEntryId,
                boardPosition:
                  _vm.contestLeaderboardPosition + "/" + _vm.contestEntryCount,
                roundNo: _vm.roundNo
              },
              on: {
                "slider-close": function(value) {
                  return (_vm.showReportSliderMenu = value)
                }
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    !_vm.hideHeaderBody
      ? _c("div", { staticClass: "contest-header-body" }, [
          _c("div", { staticClass: "contest-header-body--contest" }, [
            _c("div", { staticClass: "contest-sport-info" }, [
              _c("div", { staticClass: "contest-sport-info--right" }, [
                _c("span", { staticClass: "contest-sport-info--title" }, [
                  _vm._v(_vm._s(_vm.$t("Contests.Picks.Header.Info.Title")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "contest-sport-info--sportname" }, [
                  _vm._v(_vm._s(_vm.contestName))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "contest-sport-info--round" }, [
                  _vm._v(
                    _vm._s(_vm.$t("Contests.My.Pick.History.Table.Round.No")) +
                      " " +
                      _vm._s(_vm.roundNo)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contest-sport-info--left" }, [
                _c("span", { staticClass: "contest-sport-info--title" }, [
                  _vm._v(_vm._s(_vm.$t("Contests.Picks.Header.Points.Balance")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "contest-sport-info--balance" }, [
                  _vm._v(_vm._s(_vm.contestPointBalance))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contest-header-body--leaderbord" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("Contests.Leaderboard.Position.Title")))
            ]),
            _vm._v(" "),
            _c("span", [
              _c("b", [_vm._v(_vm._s(_vm.contestLeaderboardPosition))]),
              _vm._v("/" + _vm._s(_vm.contestEntryCount))
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33a4bc1b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a4bc1b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/contests/contestPicksHeader.vue
// module id = null
// module chunks = 